// Those files are saved on a new folder to prevent breaking changes
export const DEFAULT_STYLE_ID = 'theme';
export const CONFIG_FILENAME = 'config.json';
